/* eslint-disable camelcase */
import { type UseQueryResult, useQuery } from 'react-query';
import { type TableParamsType } from '../../types/common';
import {
  TaxPeriodService,
  type PagedResultDto_TaxPeriodDto,
} from '../../services/wealthlane-tax-services';

const useGetTaxPeriodList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
): UseQueryResult<PagedResultDto_TaxPeriodDto | undefined, unknown> => {
  const { taxPeriodId, taxApprovalStatusId, filter, sorting, skipCount, maxResultCount } =
    tableInfo;
  const taxPeriodTableList = useQuery(['getTaxPeriodTableList', tableInfo], async () => {
    return await handleRequest(
      //   TaxPeriodService.getApiTaxApiAppTaxPeriodFinancialYear()
      TaxPeriodService.getApiTaxApiAppTaxPeriodPagedSortedList(
        taxPeriodId,
        taxApprovalStatusId,
        filter,
        sorting,
        skipCount,
        maxResultCount
      )
    );
  });

  return taxPeriodTableList;
};

export default useGetTaxPeriodList;
